import { useQuery } from "@tanstack/react-query";
import { statisticsRepository } from "@/config/dataSource";

/** Lista real de participantes (uid+nome) — reaproveita o mesmo repositório
 * que já alimenta Ranking/Estatísticas, real desde a Etapa 12 (nunca o
 * `leagueAdminRepository.getParticipants`, que ainda é só Mock). */
export function useLeagueParticipants(leagueId: string | undefined) {
  return useQuery({
    queryKey: ["league-participants-raw", leagueId ?? "unknown"],
    queryFn: () => statisticsRepository.getParticipants(leagueId as string),
    enabled: Boolean(leagueId),
  });
}
